import { get } from "lodash";

import { AppEnvironmentConfig } from "./AppConfigs";
import { initAfterConfigLoad } from "../utils";
import { AppConfigs } from "../models/AppConfigs";

/* Config from config.json - START */

let configs: AppConfigs = {
  REACT_APP_HPP_HOST_CONFIG_URL_HPPORTAL: "",
  REACT_APP_DEBUG: false,
  REACT_APP_CLIENT_SERVICE_EMAIL:"",
  REACT_APP_HPP_APPINSIGHTS_CONNECTION_STRING: ""
};

let baseUrl = configs.REACT_APP_HPP_HOST_CONFIG_URL_HPPORTAL;

function updateConfigs(data: AppConfigs) {
  configs = data;
  baseUrl= data.REACT_APP_HPP_HOST_CONFIG_URL_HPPORTAL;
  reactAppDebug = data.REACT_APP_DEBUG === 1;
  clientServiceEmail = data.REACT_APP_CLIENT_SERVICE_EMAIL;
  reactAppInsights = data.REACT_APP_HPP_APPINSIGHTS_CONNECTION_STRING;
  initAfterConfigLoad();
}
export let reactAppDebug = configs.REACT_APP_DEBUG as boolean;
export let clientServiceEmail = configs.REACT_APP_CLIENT_SERVICE_EMAIL;
export let reactAppInsights = configs.REACT_APP_HPP_APPINSIGHTS_CONNECTION_STRING;
/* Config from config.json - END */

/* App level config constants - START */

//Check if running as localhost
export const IS_LOCALHOST =
  get(process.env, "NODE_ENV", "") === AppEnvironmentConfig.DEV;

//Applied endpoint for localhost -> can be changed via CLI e.g. set REACT_APP_ENDPOINT_ENV=SB
export const REACT_APP_ENDPOINT_ENV = get(
  process.env,
  "REACT_APP_ENDPOINT_ENV",
  ""
);

/* App level config constants - END */
export { updateConfigs, configs, baseUrl };
